exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".header-menu .el-dropdown-menu__item{width:90px;letter-spacing:2px;text-align:center}", "", {"version":3,"sources":["/var/jenkins_home/workspace/s01-aiart-develop-cn/s01_haiyiai_develop-cn_aiart-web-openapi/src/layout/LHeader.vue"],"names":[],"mappings":"AAEE,qCACE,WACA,mBACA,iBAAA,CAAA","file":"LHeader.vue?vue&type=style&index=1&id=5eeeee2d&lang=scss&","sourcesContent":["\n.header-menu {\n  .el-dropdown-menu__item {\n    width: 90px;\n    letter-spacing: 2px;\n    text-align: center;\n  }\n}\n"],"sourceRoot":""}]);

// exports
